import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5732be9a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionShopHeader: require('/opt/build/repo/components/section/shop/Header.vue').default,SectionShopSlider: require('/opt/build/repo/components/section/shop/Slider.vue').default,SectionClients: require('/opt/build/repo/components/section/Clients.vue').default,SectionTech: require('/opt/build/repo/components/section/Tech.vue').default,SectionShopFeatures: require('/opt/build/repo/components/section/shop/Features.vue').default,SectionShopPricing: require('/opt/build/repo/components/section/shop/Pricing.vue').default,SectionRegister: require('/opt/build/repo/components/section/Register.vue').default})
